import React from 'react';
import { useState, useEffect } from 'react';

const Timer = ({ initialMinute = 1, initialSeconds = 0, onFinish }) => {
	const [ minutes, setMinutes ] = useState(initialMinute);
	const [ seconds, setSeconds ] = useState(initialSeconds);
	const [ isComplete, setIsComplete ] = useState(false);
	const [ isTimeUp, setIsTimeUp ] = useState(false);

	let myInterval = null;
	useEffect(() => {
		myInterval = setInterval(() => {
			if (seconds > 0) {
				setSeconds(seconds - 1);
			}
			if (seconds === 0) {
				if (minutes === 0) {
					onFinish(initialMinute - minutes)
					clearInterval(myInterval);
				} else {
					setMinutes(minutes - 1);
					setSeconds(59);
					if (minutes <= 2) {
						setIsTimeUp(true);
					}
				}
			}
		}, 1000);
		return () => {
			clearInterval(myInterval);
		};
	});

	const completeExam = () => {
		clearInterval(myInterval);
		onFinish(initialMinute - minutes)
	}

	return (
		<React.Fragment>
			<h2 className="title-heading timer">
				{' '}
				{minutes}:{seconds < 10 ? `0${seconds}` : seconds}
			</h2>

			<button className="bg-[#9a6afd] text-white py-2 px-4 rounded-lg" style={{margin: '0rem 2rem'}} onClick={() => setIsComplete(true)}>Complete Exam</button>
			{/* {minutes === 0 && seconds === 0 ? null : (
				<h2 className="title-heading">
					{' '}
					{minutes}:{seconds < 10 ? `0${seconds}` : seconds}
				</h2>
			)} */}

			{
				isComplete && (
					<div className="w-full h-screen fixed inset-0 flex justify-center items-center" style={{ background: 'rgba(0, 0, 0, 0.3)', zIndex: 100 }}>
						<div className="w-fit relative bg-white rounded-xl px-8 py-5 overflow-y-auto">
							<div className="w-full max-w-[450px] p-1 md:p-2 flex-col ">
								<div className="mb-6">
									<h2 className="text-xl">Do you really want to complete the test ? </h2>
								</div>
								<div className="mb-6">
									<p className="text-sm text-gray-600">Please make sure that you have submitted the Google Form</p>
								</div>
								<div className="w-full flex gap-3">
									<button className="w-full bg-[#9a6afd] px-2 py-4 rounded-lg text-white" onClick={completeExam}>Complete Test</button>
									<button className="w-full border-2 border-[#9a6afd] px-2 py-4 rounded-lg text-[#9a6afd]" onClick={() => setIsComplete(false)}>Continue Test</button>
								</div>
							</div>
						</div>
					</div>
				)
			}
			{
				isTimeUp && (
					<div className="w-full h-screen fixed inset-0 flex justify-center items-center" style={{ background: 'rgba(0, 0, 0, 0.3)', zIndex: 100 }}>
						<div className="w-fit relative bg-white rounded-xl px-8 py-5 overflow-y-auto">
							<div className="w-full max-w-[450px] p-1 md:p-2 flex-col ">
								<div className="mb-6">
									<h2 className="text-xl">Time is almost up! </h2>
								</div>
								<div className="mb-6">
									<p className="text-sm text-gray-600">Please submit the Google Form before the time runs out</p>
								</div>
								<div className="w-full flex gap-3">
									<button className="w-full bg-[#9a6afd] px-2 py-4 rounded-lg text-white" onClick={() => setIsTimeUp(false)}>I Know</button>
								</div>
							</div>
						</div>
					</div>
				)
			}
		</React.Fragment>
	);
};

export default Timer;
